module.exports = __webpack_public_path__ + "2668575aa7e42c362f7b41cb7f81f72c.jpg";